import debounce from 'lodash.debounce'
import { useAuthentication } from 'authentication'
import { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import useChatEventsListener from './useChatEventsListener'
import { CHAT_MARGIN } from './Chat.constants'
import { useTheme } from 'styled-components'

const Chat = () => {
  const { token } = useAuthentication()

  const frameSrc = `${window.waYesChatConfig.url}?token=${token}`

  const [height, setHeight] = useState('0')
  const [width, setWidth] = useState('100%')
  const [boxShadow, setBoxShadow] = useState('none')

  useEffect(() => {
    const handleResize = debounce(() => {
      setHeight('0')
      setWidth('100%')
      setBoxShadow('none')
    }, 200)

    window.addEventListener('resize', handleResize)
    return () => {
      handleResize.cancel()
      window.removeEventListener('resize', handleResize)
    }
  }, [setBoxShadow, setHeight, setWidth])

  useChatEventsListener({ setHeight, setWidth, setBoxShadow })

  const zIndex = useTheme().zIndexes.modal

  if (!token) return null

  return ReactDOM.createPortal(
    <iframe
      src={frameSrc}
      width={width}
      height={height}
      sandbox='allow-scripts allow-same-origin allow-forms allow-popups'
      style={{
        position: 'fixed',
        maxWidth: `calc(100vw - ${CHAT_MARGIN * 2}px)`,
        bottom: 0,
        right: CHAT_MARGIN,
        boxShadow,
        zIndex
      }}
    />,
    document.body
  )
}

export default Chat
